module.exports = __webpack_public_path__ + "img/08.d25dc78a.jpg";